import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { getApi } from '../../api/endpoints.js';
import Page from "../Page.js";
import FormPartial from "./FormPartial.js";
import PageContentWrapper from "../../components/PageContentWrapper.js";
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants.js';
import Addon from '../../models/Addon.js';
import { toast } from 'react-toastify';

const New = () => {
  const [addon, setAddon] = useState(new Addon());
  const [createApi] = getApi('createAddon');
  const navigate = useNavigate();
  let addonObj = new Addon();

  const createRecord = async (params) => {
    try {
      await createApi(params).unwrap();
        navigate("/addons");
        toast.success("Successfully Created.");
    } catch(error) {
      addonObj.set_api_errors(error.data.data.errors);
      setAddon(addonObj.toStateJson());
    }
  }

  const onCreateClick = () => {
    try{
      createRecord((new Addon(addon)).toApiJson());
    } catch(error){
      setAddon(new Addon(addon));
    }
  }

  const onBackClick = () => {
    navigate("/addons");
  }

  return <Page
    uiPage={uiManager.getUiPage(PAGES.NewAddonPage.name)}
    breadcrumbs={[{ label: "Home", url: '/dashboard' }, { label: "Addons", url: '/addons' }, { label: "Add New Addons" }]}
    className={'add-addon-page'}
  >
    <PageContentWrapper contentHeading={"Add New Addon"}>
      <div className='m-3'>
        <form className="row g-4" autoComplete="off">
          <FormPartial addon={addon} setAddon={setAddon}/>
          <div className='mb-4 col-md-12'>
            <div>
              <button type="button" className="btn btn-voltup-theme" onClick={onBackClick} style={{ float: 'inline-start' }}>Back</button>
              <button type="button" className="btn btn-voltup-theme ms-3" onClick={onCreateClick}>Add Addon</button>
            </div>
          </div>
        </form>
      </div>
    </PageContentWrapper>
  </Page>
};

export default New;
